import { createApiSlice } from 'app/createApiSlice'
import {
  API_FINDORA_ITEMS,
  API_FINDORA_SYNC_EMPLOYEES,
  API_FINDORA_SYNC_ITEMS,
} from 'utils/apiList'

export const syncDataListApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'syncDataList/api',
  endpoints(builder) {
    return {
      fetchFindoraItems: builder.query({
        query({
          page = 0,
          size = 10,
          sortby = 'nameItem',
          sortdir = 'ASC',
          s,
        }) {
          return {
            url: `/${API_FINDORA_ITEMS}`,
            params: {
              page,
              size,
              sortby,
              sortdir,
              s,
            },
          }
        },
      }),
      syncFindoraItems: builder.mutation({
        query() {
          return {
            url: API_FINDORA_SYNC_ITEMS,
            method: 'POST',
          }
        },
      }),
      syncFindoraEmployees: builder.mutation({
        query() {
          return {
            url: API_FINDORA_SYNC_EMPLOYEES,
            method: 'POST',
          }
        },
      }),
    }
  },
})

export const {
  useSyncFindoraItemsMutation,
  useSyncFindoraEmployeesMutation,
  useFetchFindoraItemsQuery,
  useLazyFetchFindoraItemsQuery,
} = syncDataListApiSlice
